import styled from '@emotion/styled';

const Page = styled.div`
  background-color: #F3F3F3;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  margin: 0px;
  padding: 0px;
  position: relative;
  width: 100%;
  * {
    box-sizing: border-box;
    font-family: Montserrat, sans-serif;
  }
  min-width: 280px;
`;

export default Page;
